import { ID } from '../types/UtilityTypes'
import { EMPTY_TASK, ServerTask, Task, TaskRecord } from '../responses/tasks'
import { EMPTY_PROJECT, Project, ProjectRecord, ServerProject } from '../responses/projects'
import { reduce } from 'fp-ts/es6/Array'
import { EMPTY_PROJECT_WORK_OBJECT, ObjectRecord, ProjectWorkObject } from '../responses/objects'
import { NormalizedDepartment } from '../responses/refs/refs'
import { User, UserWithTasks } from '../responses/users'
import { modifyProp, omit } from './utils'
import { pipe } from 'fp-ts/es6/pipeable'
import { DepartmentWithUsers } from '../responses/departments'

export const normalizeTask = (changes: ServerTask) => (task: Task): Task => {
    return {
        ...EMPTY_TASK,
        ...task,
        ...omit('project', 'project_work_object', 'results')(changes),
    }
}

export const normalizeTasks = (tasks: ServerTask[]) => (state: TaskRecord): Record<ID, Task> =>
    reduce<ServerTask, TaskRecord>(state, (state, task) => pipe(state,
        modifyProp<TaskRecord, ID>(task.id, normalizeTask(task)),
        normalizeTasks(task.children || []),
    ))(tasks)

export const normalizeObject = (changes: ProjectWorkObject) => (object?: ProjectWorkObject): ProjectWorkObject => ({
    ...EMPTY_PROJECT_WORK_OBJECT,
    ...object,
    ...changes,
})

export const normalizeObjects = (objects: ProjectWorkObject[]) => (state: ObjectRecord): ObjectRecord =>
    reduce<ProjectWorkObject, ObjectRecord>(state, (state, object) =>
        modifyProp<ObjectRecord, ID>(object.id, normalizeObject(object))(state)
    )(objects)

export const normalizeProject = (changes: ServerProject) => (project?: Project): Project => {
    return {
        ...EMPTY_PROJECT,
        ...project,
        ...omit('project_work_objects')(changes),
    }
}

export const normalizeProjects = (projects: ServerProject[]) => (state: ProjectRecord): ProjectRecord =>
    reduce<ServerProject, ProjectRecord>(state, (state, project) =>
        modifyProp<ProjectRecord, ID>(project.id, normalizeProject(project))(state)
    )(projects)

export const normalizeUser = (user: UserWithTasks): User => omit('tasks')(user)

export const normalizeDepartments = (department: DepartmentWithUsers): NormalizedDepartment => ({
    ...department,
    users: department.users.map(normalizeUser),
})
